import { Component, OnInit, Input, ElementRef, ContentChild, TemplateRef, forwardRef, HostBinding } from '@angular/core';
import { CfSelectableComponent } from '../selectable/selectable.component';
import { SelectableModel } from '../../models/selectable/selectable.model';
import { SelectableStylingModel } from '../../models/selectable/selectable-styling.model';
import { CheckboxTemplates } from '../../templates/checkbox.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Checkbox Component</p>
 * <pre>
 * <code>
 * import {{'{'}} SelectableModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} SelectableStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-checkbox<code>></code><code><</code><code>/</code>cf-checkbox<code>></code>
 * </code>
 * </pre>
 */
export class CfCheckboxComponent extends CfSelectableComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden
 */
cfCheckboxTemplate;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new SelectableModel();
    this.styling = new SelectableStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('checkbox', CheckboxTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'CHECKBOX').then( sampler => {
        this.checked = this.properties.checked;
        if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
        // console.log('CHECKBOX', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-checkbox',
  template: "<cf-selectable> <div *ngIf=\"properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-selectable'\"> <div class=\"cf-checkbox-group-container {{properties?.itemPosition}}\" [class.has-no-item]=\"hasNoItem\"> <md-checkbox class=\"{{activeTemplate.style?.button?.class}} {{styling?.button?.class}} {{getDynamicClasses(activeTemplate.style?.button?.dynamicClass)}} {{getDynamicClasses(styling?.button?.dynamicClass)}}\" [ngClass]=\"'cf-checkbox'\" [(ngModel)]=\"checked\" [(checked)]=\"checked\" [disabled]=\"properties?.disable\" [labelPosition]=\"properties?.itemPosition || 'after'\" [color]=\"styling?.button?.themeColor || activeTemplate.style?.button?.themeColor\" (click)=\"notifyGroup()\"> <div *ngIf=\"!cfCheckboxTemplate && !!properties?.item\" [innerHtml]=\"properties?.item | safePipe\"></div> <div *ngIf=\"cfCheckboxTemplate\" [ngTemplateOutlet]=\"cfCheckboxTemplate\" [ngOutletContext]=\"{cfIndex: i, cfItem: properties?.item}\"></div> </md-checkbox> </div> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div> </cf-selectable> ",
  styles: [":host { position: relative; z-index: 0; display: inline-flex; } :host.notification-clickable cf-notification:hover { cursor: pointer; } .cf-checkbox-group-container { display: inline-flex; flex-direction: column; } .cf-checkbox-group-container.before { text-align: right; } .cf-checkbox-group-container .mat-checkbox-disabled /deep/ * { color: #b0b0b0; } "],
  providers: [{ provide: CfSelectableComponent, useExisting: forwardRef(() => CfCheckboxComponent) }]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'cfCheckboxTemplate': [{ type: ContentChild, args: [TemplateRef, ] },],
};
}

function CfCheckboxComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCheckboxComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCheckboxComponent.ctorParameters;
/** @type {?} */
CfCheckboxComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfCheckboxComponent.prototype.notificationClickable;
/**
 * @hidden
 * @type {?}
 */
CfCheckboxComponent.prototype.cfCheckboxTemplate;
/**
 * @hidden
 * @type {?}
 */
CfCheckboxComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
